import React, { useContext, useState, useEffect } from "react";
import { icons } from "../../../constants";
import { TranslationsContext } from "../../../utils/TranslationsContext";
import AccreditationInput from "../../AccreditationInput/AccreditationInput";
import AccreditationButton from "../../AccreditationButton/AccreditationButton";
import { apiRoutes } from "../../../utils/apiRoutes";
import { createData } from "../../../utils/methods";
import { useNavigate } from "react-router-dom";
import Loader from "../../Loader/Loader";
import { useAlert } from "../../../utils/AlertContext";

const Status = ({
  onCloseClick,
  personStatus,
  personId,
  handleUpdateData,
  statusChange,
}) => {
  const [message, setMessage] = useState("");
  const { t } = useContext(TranslationsContext);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { showAlert } = useAlert();

  console.log("personStatus", personStatus);

  const handleSaveClick = async (status) => {
    setIsLoading(true);

    const personIdToUpdate = statusChange?.id ?? personId;
    const statusToUpdate = status ?? personStatus;

    const dataToSend = {
      status: statusToUpdate,
      id: personIdToUpdate,
      ...(message && { poruka: message }),
    };

    try {
      const route = apiRoutes.updatePersonStatus;
      const response = await createData(
        route,
        dataToSend,
        showAlert,
        navigate,
        t,
      );

      if (!response) return;

      const data = response.data || response;

      // Handle partial failure
      if (data.failed && data.failed.length > 0) {
        // Partial success - some succeeded, some failed
        const successCount = data.count || 0;
        const failedCount = data.failed.length;

        // Build failure messages
        const failureMessages = data.failed.map((f) => {
          if (f.name && f.surname) {
            return `${f.name} ${f.surname} (${f.id}): ${f.reason}`;
          } else {
            return `${f.id}: ${f.reason}`;
          }
        });

        // Show warning/partial success message
        showAlert(
          `Updated ${successCount} person(s). ${failedCount} failed:\n${failureMessages.join("\n")}`,
          "warning",
        );

        // Only update local state if at least one succeeded
        if (successCount > 0) {
          handleUpdateData({
            status: statusToUpdate,
            id: personIdToUpdate,
            ...(message && { poruka: message }),
          });
        }
        return;
      }

      // Full success
      const successCount = data.count || 1;
      console.log("Podaci su uspešno sačuvani:", data);
      handleUpdateData({
        status: statusToUpdate,
        id: personIdToUpdate,
        ...(message && { poruka: message }),
      });
      showAlert(`Successfully updated ${successCount} person(s)`, "success");
      onCloseClick();
    } catch (error) {
      console.error("API poziv nije uspeo:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Handle Enter key to trigger primary action
    const handleEnterKey = (event) => {
      if (
        event.key === "Enter" &&
        !event.shiftKey &&
        !event.ctrlKey &&
        !event.metaKey
      ) {
        // Don't trigger if user is typing in a textarea or input
        const target = event.target;
        if (
          target.tagName === "TEXTAREA" ||
          (target.tagName === "INPUT" && target.type !== "submit")
        ) {
          return;
        }
        event.preventDefault();
        if (statusChange) {
          // If statusChange exists, default to accept action
          if (statusChange.status !== "odobren") {
            handleSaveClick("odobren");
          }
        } else {
          handleSaveClick();
        }
      }
    };

    document.addEventListener("keydown", handleEnterKey);

    return () => {
      document.removeEventListener("keydown", handleEnterKey);
    };
  }, [statusChange, personStatus]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="flex-direction-column gap-24 justify-between status-modal">
      <div className="flex-direction-row justify-between width-100">
        <p className="inria-sans-400 font-16 modal-title">
          {t("STATUS_CHANGE")}
        </p>
        <img
          className="pointer"
          src={icons.close_gray}
          onClick={onCloseClick}
          alt="X"
        />
      </div>
      <div className="flex-direction-column gap-24 items-center">
        <p
          className="inria-sans-400 font-20"
          style={{ color: "var(--text-black)" }}
        >
          {statusChange?.fullName}
        </p>
        <div className="flex-direction-column gap-48 width-100">
          <AccreditationInput
            className="status-textarea"
            label={t("NOTE")}
            type="text-area"
            setInputValue={(value) => setMessage(value)}
            value={message}
          />
          {statusChange ? (
            <div className="flex-direction-row gap-24 width-100 person-card-buttons">
              <AccreditationButton
                onClick={() => handleSaveClick("odbijen")}
                type="decline"
                title={t("REJECT")}
                icon={icons.decline}
                className="person-card-btn"
                disabled={statusChange?.status === "odbijen"}
              />
              <AccreditationButton
                onClick={() => handleSaveClick("odobren")}
                type="accept"
                title={t("ACCEPT")}
                icon={icons.accept}
                className="person-card-btn"
                disabled={statusChange?.status === "odobren"}
              />
            </div>
          ) : (
            <AccreditationButton
              onClick={() => handleSaveClick()}
              type="save"
              title={t("BTN_SAVE")}
              className="modal-btn"
              backgroundColor={
                personStatus === "odobren"
                  ? "var(--Green-accept)"
                  : personStatus === "odbijen"
                    ? "var(--Red-1)"
                    : ""
              }
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default Status;
